module.exports = __webpack_public_path__ + "img/preview.c8b7a86a.png";